import { formatDate, handleImageError } from "helpers/globalFunction";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Zoom from "react-medium-image-zoom";

const DetailModalLogVehicle = ({ show, onCloseClick, data }: any) => {
  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="lg"
    >
      <ModalHeader className="border-0 pb-0" toggle={onCloseClick}>
        <h5 className="mb-0 fw-semibold">Detail Log Kendaraan</h5>
      </ModalHeader>

      <ModalBody className="p-4">
        {/* Info Card */}
        <div className="bg-light rounded-3 p-3 mb-4">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="d-flex align-items-center gap-2 mb-2">
                <i className="ri-login-box-line text-success fs-5"></i>
                <small className="text-muted fw-medium">Tanggal Masuk</small>
              </div>
              <div className="fw-semibold">
                {formatDate(data.inDate, "fullDateTime")}
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex align-items-center gap-2 mb-2">
                <i className="ri-logout-box-line text-danger fs-5"></i>
                <small className="text-muted fw-medium">Tanggal Keluar</small>
              </div>
              <div className="fw-semibold">
                {formatDate(data.outDate, "fullDateTime")}
              </div>
            </div>
          </div>
        </div>

        {/* Vehicle Info */}
        <div className="row g-3 mb-4">
          <div className="col-md-6">
            <div className="border rounded-3 p-3">
              <small className="text-muted d-block mb-1">Plat Nomor</small>
              <div className="fs-5 fw-bold text-dark">{data.licenseNumber}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="border rounded-3 p-3">
              <small className="text-muted d-block mb-1">Nama Pengemudi</small>
              <div className="fs-6 fw-semibold">{data.driverName}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="border rounded-3 p-3">
              <small className="text-muted d-block mb-1">
                Kategori Kendaraan
              </small>
              <span className="badge bg-primary-subtle text-primary fs-6">
                {data.category}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="border rounded-3 p-3">
              <small className="text-muted d-block mb-1">
                Kategori Pemilik
              </small>
              <span className="badge bg-info-subtle text-info fs-6">
                {data.categoryOwner}
              </span>
            </div>
          </div>
        </div>

        {/* Photos Section */}
        <div className="mb-4">
          <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
            <i className="ri-image-line text-success"></i>
            Foto Masuk
          </h6>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="border rounded-3 overflow-hidden shadow-sm">
                <Zoom>
                  <img
                    src={data.firstInPicture}
                    alt="Foto Masuk 1"
                    className="w-100"
                    style={{ height: "250px", objectFit: "cover" }}
                    onError={handleImageError}
                  />
                </Zoom>
              </div>
            </div>
            <div className="col-md-6">
              <div className="border rounded-3 overflow-hidden shadow-sm">
                <Zoom>
                  <img
                    src={data.secondInPicture}
                    alt="Foto Masuk 2"
                    className="w-100"
                    style={{ height: "250px", objectFit: "cover" }}
                    onError={handleImageError}
                  />
                </Zoom>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
            <i className="ri-image-line text-danger"></i>
            Foto Keluar
          </h6>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="border rounded-3 overflow-hidden shadow-sm">
                <Zoom>
                  <img
                    src={data.firstOutPicture}
                    alt="Foto Keluar 1"
                    className="w-100"
                    style={{ height: "250px", objectFit: "cover" }}
                    onError={handleImageError}
                  />
                </Zoom>
              </div>
            </div>
            <div className="col-md-6">
              <div className="border rounded-3 overflow-hidden shadow-sm">
                <Zoom>
                  <img
                    src={data.secondOutPicture}
                    alt="Foto Keluar 2"
                    className="w-100"
                    style={{ height: "250px", objectFit: "cover" }}
                    onError={handleImageError}
                  />
                </Zoom>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

DetailModalLogVehicle.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  data: PropTypes.any,
};

export default DetailModalLogVehicle;
